






































import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import { WaterMetersApi, WaterMonitorsApi, WaterTotalizerCorrection } from '@/api';
import { Constants } from '@/common/Constants';
import { AxiosResponse } from 'axios';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		VueCtkDateTimePicker,
	},
})
export default class TotalizerCorrectionModal extends Vue {
	@Prop({ required: true, type: Number })
	private entityId!: number;

	@Prop({ required: true, type: String })
	private entityType!: string;

	@Prop({ required: true, type: Function })
	private onCorrectionApplied!: () => Promise<void>;

	public get totalizerReadingValid(): boolean {
		return typeof this.totalizerReading === 'number';
	}

	public dateFormat: string = 'YYYY-MM-DD h:mm a';
	public correctionDate: string = moment()
		.format(this.dateFormat)
		.toString();
	public minDate: string = moment()
		.startOf('day')
		.subtract(7, 'days')
		.format(this.dateFormat)
		.toString();
	public totalizerReading: number | null = null;
	public submitted: boolean = false;
	public loading: boolean = false;

	private toast: Toast = new Toast();

	public onCorrectionDateChanged(newDate: string): void {
		this.correctionDate = newDate;
	}

	public dismiss(): void {
		this.$bvModal.hide('totalizerCorrectionModal');
	}

	public async applyCorrection(): Promise<void> {
		this.submitted = true;
		this.loading = true;
		if (!this.totalizerReading) {
			this.loading = false;
			return;
		}
		const correctionTs: number = Math.floor(
			moment(this.correctionDate, 'YYYY-MM-DD h:mm a').valueOf() / 1000,
		);
		try {
			await this.correctionApiCall(this.entityId, {
				correctionTs,
				processedTs: Math.floor(moment().valueOf() / 1000),
				totalizerReading: this.totalizerReading * 1000,
			});
			await this.onCorrectionApplied();
			setTimeout(() => {
				this.toast.makeToast('Correction applied', 'Success', 'success');
				this.dismiss();
				this.loading = false;
			}, 500);
		} catch (e) {
			const errorResponse = ApiUtils.handleApiError(e, 'Failed to send totalizer correction');
			this.toast.makeToast(errorResponse.errorMessage, 'Error', 'danger');
			this.loading = false;
		}
	}

	private get correctionApiCall(): (
		waterMonitorId: number,
		waterTotalizerCorrectionData: WaterTotalizerCorrection,
	) => Promise<AxiosResponse<void>> {
		if (this.entityType === Constants.ENTITY_TYPE_WATER_MONITOR) {
			return new WaterMonitorsApi().applyMonitorTotalizerCorrection;
		}
		return new WaterMetersApi().applyMeterTotalizerCorrection;
	}
}
